import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { axiosUserManagement } from "../../axios";

import { SiteConstants } from "../../constants/constant";
import { objectToArray } from "../../util/commonFunctions";
import { updateFormElements, checkFormValid } from "../../util/FormHelper";
import ResetPassword from "../../components/forms/ResetPassword";
import ResetPasswordEmail from "../../components/forms/ResetPassword/ResetPasswordEmail";
import ResetPasswordConfig from "../../components/formsConfig/ResetPasswordConfig";
import { setToken, setUser } from "../../actions";
import { handleActionError } from "../../util/error";

class ResetPasswordComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: SiteConstants.ResetPassword,
      propsStep: SiteConstants.ResetPassword,
      ...{ ResetPasswordConfig },
      btnDisabled: true,
      message: null,
      success: false
    };
  }

  componentDidMount() {}

  lazyLoadComponent = stepName => {
    this.setState({
      activeStep: stepName,
      btnDisabled: true,
      ...{ ResetPasswordConfig },
      success: false,
      message: null
    });
  };

  onChangeHandler = (event, formName) => {
    const updatedFrom = updateFormElements(
      event,
      event.target.getAttribute("type"),
      this.state[formName]
    );
    this.setState({
      [formName]: updatedFrom,
      btnDisabled: !checkFormValid(updatedFrom).formValid
    });
  };

  onBlurHandler = (event, formName) => {
    this.setState({
      [formName]: updateFormElements(event, "validation", this.state[formName]),
      btnDisabled: !checkFormValid(this.state[formName]).formValid
    });
  };

  ResetPasswordHandler = formName => {
    event.preventDefault();
    let returnFormConfig = checkFormValid(this.state[formName]);

    if (returnFormConfig.formValid) {
      const formData = {};
      this.setState({
        [formName]: returnFormConfig.form,
        loader: true
      });
      for (let formElementIdentifier in this.state[formName]) {
        formData[formElementIdentifier] = this.state[formName][
          formElementIdentifier
        ].value;
      }
      axiosUserManagement
        .post(
          "/forgot/password",

          formData,
          {
            "cache-control": "no-cache",
            "content-type": "application/json"
          }
        )
        .then(res => {
          this.setState({
            loader: false,
            success: true
          });
        })
        .catch(err => {
         handleActionError("Error hitting /forgot/password POST endpoint:", err);
          this.setState({
            loader: false,
            message: err.response.data.message
          });
        });
    } else {
      this.setState({
        [formName]: returnFormConfig.form
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <Helmet title="Reset password | ausbiz" />
        <div className="background">
          <div className="container">
            <div className="row">
              <div className="col-12 no-gutter-col">
                <div className="signInUpFlow" style={{maxWidth: "530px", margin: "45px auto", background: "#fff", padding: "40px 60px"}}>
                  {this.state.activeStep === SiteConstants.ResetPassword && (
                    <ResetPassword
                      lazyLoadComponent={this.lazyLoadComponent}
                      nextPage={SiteConstants.ResetPasswordEmail}
                      form={objectToArray(this.state.ResetPasswordConfig)}
                      formName="ResetPasswordConfig"
                      btnDisabled={this.state.btnDisabled}
                      onChangeHandler={this.onChangeHandler}
                      onBlurHandler={this.onBlurHandler}
                      sucessHandler={this.ResetPasswordHandler}
                      message={this.state.message}
                      sucessState={this.state.success}
                    />
                  )}
                  {this.state.activeStep ===
                    SiteConstants.ResetPasswordEmail && <ResetPasswordEmail />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.auth.token,
    provider: state.auth.provider
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setToken: (token, provider) => dispatch(setToken(token, provider)),
    setUser: token => dispatch(setUser(token))
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(ResetPasswordComp)
};
